import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AddMatchVideo } from './Add';
import { MatchVideoDetail } from './Detail';
import { MatchVideoList } from './List';

export const MatchVideosRoutes = ({ match }) => (
  <Switch>
    <Route exact path={match.url} component={MatchVideoList} />
    <Route path={`${match.url}/add`} component={AddMatchVideo} />
    <Route path={`${match.url}/:id`} component={MatchVideoDetail} />
  </Switch>
);
